import React, { ComponentProps } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

type Props = {
  value: ComponentProps<typeof FormattedDate>['value'];
  hour?: ComponentProps<typeof FormattedTime>['hour'];
  minute?: ComponentProps<typeof FormattedTime>['minute'];
  second?: ComponentProps<typeof FormattedTime>['second'];
};

export const FormattedDateTime = ({
  value,
  hour = '2-digit',
  minute = '2-digit',
  second = '2-digit',
}: Props) => {
  return (
    <>
      <FormattedDate value={value} />{' '}
      <FormattedTime
        value={value}
        hour={hour}
        minute={minute}
        second={second}
      />
    </>
  );
};
